import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SearchEntityStateActions, } from '../../reducers/SearchEntityReducer/SearchEntityReducer.js';
import { ConnectionPagingCount } from '../ConnectionPagingCount/ConnectionPagingCount.js';
export function SearchEntityPagingCount({ searchEntityState, dispatchSearchEntityState, }) {
    const handlePagingChange = useCallback((paging) => {
        dispatchSearchEntityState(new SearchEntityStateActions.SetPaging(paging));
    }, [dispatchSearchEntityState]);
    return (_jsx(ConnectionPagingCount, { connection: searchEntityState.connection, paging: searchEntityState.paging, pagingCount: searchEntityState.requestedCount, totalCount: searchEntityState.totalCount, onPagingChange: handlePagingChange }));
}
//# sourceMappingURL=SearchEntityPagingCount.js.map